import dayjs from 'dayjs';

import { AlertTriangle, ExternalLink } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { ListViewCellConfiguration, ListViewTypes } from './model/ListViewCell';

import { useNavigationService } from '../../../../services/navigate-service';
import { ROUTES } from '../../../../config/routes';

import { Typography } from '@/components/ui/typography';

export const ListViewCell = ({
  type,
  address,
  lastOrder,
  age,
  propertyStatus,
  total,
  orderId,
  orderDate,
  isOrderConfirm,
  description
}: ListViewCellConfiguration) => {
  const { navigateTo } = useNavigationService();

  const redirectToOrder = () => {
    // DV-2416: filter the Orders list by the property address (matched server-side
    // on `propertyAddress`), NOT the row's `orderNumber`. Migrated properties carry a
    // stale/wrong `Property.orderNumber` that matches no order, so keying on it made
    // the filter return "No Matches". Mirrors PropertyDetailDrawer.handleViewAllOrders.
    navigateTo(ROUTES.ORDERS, {
      propertyAddress: (address ?? '').split('\n')[0] ?? ''
    });
  };

  const getLastOrderDate = () => {
    let lastOrderDate = '-';
    if (orderDate) {
      lastOrderDate = dayjs(new Date(orderDate * 1000)).format('MMM DD, YYYY');
    }

    return lastOrderDate;
  };

  if (type === ListViewTypes.PROPERTY_ADDRESS) {
    return (
      <section>
        {/* Commented till the time order implementation

        <div className="link">
          <ButtonUI
            text={
              <Typography variant="body-semibold">#5611</Typography>
            }
            variant="link"
            onChildClick={alert}
          />
        </div> */}
        <div>
          <Typography variant="body-medium" className="inline-block whitespace-pre-line max-w-[250px] min-w-[250px] overflow-hidden text-ellipsis">{address?.trim() || '-'}</Typography>
        </div>
      </section>
    );
  } else if (type === ListViewTypes.LAST_ORDER && lastOrder && orderDate) {
    return (
      <section>
        <div className="mb-2.5">
          <Button
            variant="link"
            className="!h-3 !text-sm !font-medium !underline !p-0 [&_svg]:text-sm [&_svg]:text-link-icon"
            onClick={() => redirectToOrder()}
          >
            {lastOrder} <ExternalLink className="h-3.5 w-3.5 inline" />
          </Button>
        </div>
        <div>
          <Typography variant="body-medium">{getLastOrderDate()}</Typography>
        </div>
      </section>
    );
  } else if (type === ListViewTypes.AGE_OF_PHOTOS && age) {
    return (
      <section>
        <div className="mb-2">
          <AlertTriangle className="h-[18px] w-[18px] text-warning relative -top-0.5 mr-0.5 inline" />{' '}
          <Typography variant="body">487 days old photos</Typography>
        </div>
        <div className="underline [&_span]:text-link-svg [&_svg]:text-link-svg">
          <Typography variant="body-medium">Reorder photos</Typography>
        </div>
      </section>
    );
  } else if (type === ListViewTypes.PROPERTY_STATUS) {
    return (
      <Typography variant="body-medium">{propertyStatus || '-'}</Typography>
    );
  } else if (type === ListViewTypes.TOTAL) {
    return (
      <Typography variant="body-semibold" className="text-foreground">{total ? `$ ${total}` : '-'}</Typography>
    );
  } else if (type === ListViewTypes.DESCRIPTION) {
    return (
      <Typography variant="body">{description || '-'}</Typography>
    );
  } else if (type === ListViewTypes.ORDER_ID) {
    if (isOrderConfirm) {
      return (
        <Typography variant="body-semibold">{orderId || '-'}</Typography>
      );
    } else {
      return (
        <section>
          <div>
            <Typography variant="body-semibold">{orderId || '-'}</Typography>
          </div>
          {/* <div>
            <Typography variant="body">{orderDate || '-'}</Typography>
          </div> */}
        </section>
      );
    }
  } else {
    return <>-</>;
  }
};
